import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, Button, Checkbox, FormControlLabel, Box } from '@mui/material';
import Navbar from '../../components/Features/Navbar';
import Footer from '../../components/Home/Footer';

const ContratEntretienIndividuel = () => {
    const navigate = useNavigate();
    const [acceptedContract, setAcceptedContract] = useState(false);
    const [showPayment, setShowPayment] = useState(false);

    useEffect(() => {
        document.title = 'Contrat Entretien Individuel | Tsahal Connection';
    }, []);

    const handleValidateContract = () => {
        if (acceptedContract) {
            // Afficher la page de paiement intégrée
            setShowPayment(true);
        } else {
            alert("Vous devez accepter les termes du contrat pour continuer.");
        }
    };

    if (showPayment) {
        return (
            <div>
                <Navbar />
                <Container maxWidth="lg" style={{ marginTop: '2rem', marginBottom: '4rem' }}>
                    <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
                        <Typography variant="h3" align="center" gutterBottom style={{ fontFamily: 'Montserrat', fontWeight: '700', color: '#2593C4', marginBottom: '2rem' }}>
                            Finaliser votre Inscription
                        </Typography>
                        <Typography variant="h6" align="center" gutterBottom style={{ fontFamily: 'Montserrat', marginBottom: '2rem' }}>
                            Entretien Individuel - 450₪ TTC
                        </Typography>
                        <iframe
                            src="https://mrng.to/CcDLuHP6wj"
                            width="100%"
                            height="800"
                            style={{ border: '1px solid #ddd', borderRadius: '8px' }}
                            title="Paiement Morning"
                        />
                        <Box style={{ textAlign: 'center', marginTop: '2rem' }}>
                            <Button
                                variant="outlined"
                                size="large"
                                onClick={() => setShowPayment(false)}
                                style={{
                                    borderColor: '#2593C4',
                                    color: '#2593C4',
                                    padding: '1rem 3rem',
                                    fontSize: '1.1rem',
                                    fontFamily: 'Montserrat',
                                    fontWeight: '600'
                                }}
                            >
                                Retour au Contrat
                            </Button>
                        </Box>
                    </Paper>
                </Container>
                <Footer />
            </div>
        );
    }

    return (
        <div>
            <Navbar />
            <Container maxWidth="lg" style={{ marginTop: '2rem', marginBottom: '4rem' }}>
                <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
                    <Typography variant="h3" align="center" gutterBottom style={{ fontFamily: 'Montserrat', fontWeight: '700', color: '#2593C4', marginBottom: '2rem' }}>
                        Contrat Entretien Individuel
                    </Typography>

                    <Paper elevation={1} style={{ marginBottom: '2rem', padding: '2rem', border: '1px solid #ddd' }}>
                        <Typography variant="h6" gutterBottom style={{ fontFamily: 'Montserrat', fontWeight: '600', color: '#2593C4', marginBottom: '1.5rem' }}>
                            Contrat de Service - Entretien Individuel
                        </Typography>
                        
                        <Box style={{ fontFamily: 'Montserrat', lineHeight: '1.7', fontSize: '0.95rem' }}>
                            
                            <Typography paragraph style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#2593C4', marginBottom: '1rem' }}>
                                🧭 Entretien individuel
                            </Typography>
                            
                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                <strong>Expert Connection – Tsahal Connection</strong><br/>
                                Entretien ponctuel destiné aux candidats souhaitant bénéficier d'un temps d'échange ciblé avec l'équipe Expert Connection, sans engagement dans un accompagnement complet.
                            </Typography>

                            <Typography paragraph style={{ backgroundColor: '#fff3cd', padding: '0.8rem', borderRadius: '6px', borderLeft: '4px solid #ffc107', marginBottom: '1.5rem' }}>
                                <strong>ℹ️ Mention importante</strong><br/>
                                Par souci de lisibilité, le présent texte est rédigé au masculin, mais il s'adresse bien entendu à toutes et à tous, sans distinction de genre.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2593C4', marginTop: '2rem', marginBottom: '1rem' }}>
                                ✅ Ce qui est inclus dans l'entretien
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                <strong>1 entretien individuel</strong><br/>
                                (durée maximale : 45 minutes)
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                <strong>L'entretien peut porter au choix sur l'un des thèmes suivants :</strong><br/>
                                • rendez-vous d'orientation générale<br/>
                                • orientation sur les postes dans Tsahal<br/>
                                • rendez-vous Mehinot<br/>
                                • Cheelon Haadafot (questionnaire de préférences)<br/>
                                • parcours d'études avant ou après le service militaire
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                <strong>Format de l'entretien :</strong><br/>
                                • en visio<br/>
                                • ou en présentiel, dans les locaux de Tsahal Connection (selon disponibilité)
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                <strong>Possibilité de mise en relation avec d'anciens ou actuels soldats francophones</strong><br/>
                                (selon disponibilité et cohérence avec la demande du candidat)
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#dc3545', marginTop: '2rem', marginBottom: '1rem' }}>
                                ❌ Ce qui n'est pas inclus
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                <strong>Cet entretien ne peut en aucun cas être utilisé pour :</strong><br/>
                                • une préparation au Tsav Rishon<br/>
                                • une préparation au Yom Hamea<br/><br/>
                                Ces préparations font l'objet de prestations spécifiques ou d'accompagnements dédiés.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#dc3545', marginTop: '2rem', marginBottom: '1rem' }}>
                                ❌ Ce qui n'est pas garanti
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                • L'obtention d'un poste précis<br/>
                                • Un profil médical ou notes aux examens psychotechniques spécifiques<br/>
                                • L'acceptation de la candidature par Tsahal<br/><br/>
                                Les décisions finales relèvent exclusivement de Tsahal.<br/>
                                La prestation repose sur une obligation de moyens, et non de résultat.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2593C4', marginTop: '2rem', marginBottom: '1rem' }}>
                                📝 Engagements du candidat
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                Le candidat s'engage à remplir le formulaire de contact et d'inscription disponible sur le site de Tsahal Connection, condition nécessaire à la tenue de l'entretien.
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                <strong>Le candidat est responsable :</strong><br/>
                                • de prendre rendez-vous avec l'équipe<br/>
                                • de respecter les horaires convenus<br/>
                                • de communiquer toute modification ou difficulté en amont
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2593C4', marginTop: '2rem', marginBottom: '1rem' }}>
                                💳 Tarif
                            </Typography>

                            <Typography paragraph style={{ backgroundColor: '#e7f3ff', padding: '1rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
                                <strong>Entretien individuel</strong><br/>
                                👉 <strong style={{ fontSize: '1.1rem', color: '#2593C4' }}>450 ₪ TTC</strong><br/>
                                Le paiement est effectué au bénéfice de la société Raphael Madar – Tsahal Connection.<br/>
                                Le paiement permet à la fois l'accès à la prestation choisie et le soutien financier du projet Tsahal Connection dans sa globalité, afin de contribuer à sa continuité et à son développement.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#dc3545', marginTop: '2rem', marginBottom: '1rem' }}>
                                ⚠️ Conditions de paiement – Non-remboursement
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                • Le paiement est requis avant la tenue de l'entretien<br/>
                                • Tout paiement validé est définitif et non remboursable<br/>
                                • Toute annulation ou demande de report effectuée à moins de <strong>48 heures ouvrées</strong> avant le rendez-vous ne donnera lieu à aucun remboursement, sauf décision exceptionnelle du Directeur de Tsahal Connection<br/>
                                • En cas d'absence du candidat au rendez-vous, l'entretien est considéré comme effectué<br/>
                                • Sans réception préalable du paiement, l'entretien ne pourra pas être assuré
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2593C4', marginTop: '2rem', marginBottom: '1rem' }}>
                                ➕ Clause complémentaire – Cas exceptionnels
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                En cas de cessation d'activité, fermeture, dépôt de bilan de la société Raphael Madar – Tsahal Connection, OU en cas d'indisponibilité prolongée de l'équipe liée à des obligations militaires (période de réserve / miluim), lorsque ces obligations rendent impossible ou significativement entravent la bonne exécution des prestations prévues.
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                Le candidat reconnaît expressément que, même dans ces cas exceptionnels, <strong>les sommes versées restent non remboursables</strong>, conformément aux conditions de paiement acceptées.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#28a745', marginTop: '2rem', marginBottom: '1rem' }}>
                                ✔️ Validation
                            </Typography>

                            <Typography paragraph style={{ backgroundColor: '#d4edda', padding: '1rem', borderRadius: '8px', borderLeft: '4px solid #28a745' }}>
                                En confirmant et en procédant au paiement, vous reconnaissez avoir pris connaissance des informations ci-dessus et acceptez l'intégralité des conditions de la prestation.
                            </Typography>
                        </Box>
                    </Paper>

                    {/* Section Acceptation */}
                    <Paper elevation={2} style={{ 
                        padding: '1.5rem', 
                        marginTop: '2rem', 
                        marginBottom: '2rem',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '12px'
                    }}>
                        <Box style={{ textAlign: 'center' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={acceptedContract}
                                        onChange={(e) => setAcceptedContract(e.target.checked)}
                                        color="primary"
                                        sx={{ 
                                            '& .MuiSvgIcon-root': { 
                                                fontSize: { xs: 28, sm: 32 } 
                                            } 
                                        }}
                                    />
                                }
                                label={
                                    <Typography style={{ 
                                        fontFamily: 'Montserrat', 
                                        fontWeight: '500',
                                        fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                                        lineHeight: '1.4',
                                        textAlign: 'left'
                                    }}>
                                        J'ai lu et j'accepte les termes et conditions de ce contrat d'entretien individuel
                                    </Typography>
                                }
                                sx={{
                                    alignItems: 'center',
                                    margin: 0,
                                    '& .MuiFormControlLabel-label': {
                                        paddingLeft: '8px'
                                    }
                                }}
                            />
                        </Box>
                    </Paper>

                    {/* Section Boutons */}
                    <Box style={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        gap: '1rem',
                        marginTop: '2rem',
                        paddingBottom: '2rem'
                    }}>
                        <Button
                            variant="contained"
                            size="large"
                            fullWidth
                            onClick={handleValidateContract}
                            disabled={!acceptedContract}
                            sx={{
                                backgroundColor: acceptedContract ? '#2593C4' : '#ccc',
                                color: 'white',
                                padding: { xs: '1rem 2rem', sm: '1.2rem 3rem' },
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                fontFamily: 'Montserrat',
                                fontWeight: '600',
                                borderRadius: '12px',
                                textTransform: 'none',
                                boxShadow: acceptedContract ? '0 4px 12px rgba(37, 147, 196, 0.3)' : 'none',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: acceptedContract ? '#1e7ba8' : '#ccc',
                                    transform: acceptedContract ? 'translateY(-2px)' : 'none',
                                    boxShadow: acceptedContract ? '0 6px 16px rgba(37, 147, 196, 0.4)' : 'none'
                                },
                                '&:disabled': {
                                    backgroundColor: '#ccc',
                                    color: '#999'
                                }
                            }}
                        >
                            Valider et Procéder au Paiement
                        </Button>
                        
                        <Button
                            variant="outlined"
                            size="large"
                            fullWidth
                            onClick={() => navigate('/expert-connection')}
                            sx={{
                                borderColor: '#2593C4',
                                color: '#2593C4',
                                padding: { xs: '1rem 2rem', sm: '1.2rem 3rem' },
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                fontFamily: 'Montserrat',
                                fontWeight: '600',
                                borderRadius: '12px',
                                textTransform: 'none',
                                borderWidth: '2px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#2593C4',
                                    color: 'white',
                                    transform: 'translateY(-1px)',
                                    borderWidth: '2px'
                                }
                            }}
                        >
                            ← Retour
                        </Button>
                    </Box>
                </Paper>
            </Container>

            <Footer />
        </div>
    );
};

export default ContratEntretienIndividuel;